import { gql } from "@apollo/client";

export const getTags = gql`
    query GetTags($entityType: String) {
        getTags(entityType: $entityType) {
            items {
                id
                name
            }
        }
    }
`;
